<template>
    <page>
        <fast-table
            v-if="dataLoaded"
            :sections="sections"
            :headers="headers"
            :data="tableData"
            @click="currentReimbursementTypeSlug = $event.slug"
        >
            <template v-slot:table-actions>
                <button type="button" class="btn btn-primary btn-collapse-md" @click.prevent="currentReimbursementTypeSlug = null; addModalOpen = true">
                    <i class="far fa-fw fa-plus"></i>
                    <span class="btn-text">Add Reimbursement Type</span>
                </button>
            </template>
        </fast-table>

        <sidebar
            :reimbursement-type="currentReimbursementType"
            v-if="currentReimbursementTypeSlug"
            @updated="onUpdate($event)"
            @deleted="currentReimbursementTypeSlug = null; getData()"
            @close="currentReimbursementTypeSlug = null"
        />
        <add-modal v-if="addModalOpen" @updated="getData()" @close="addModalOpen = false" />

    </page>
</template>

<script>
import FastTable from '@/components/FastTable'
import Page from '@/components/Page'
import AddModal from './components/ReimbursementTypeModal'
import Sidebar from './components/ReimbursementTypeSidebar'

export default {
    components: {FastTable, Page, Sidebar, AddModal, },
    computed: {
        currentReimbursementType() {
            return this.reimbursementTypes.find(r => r.slug == this.currentReimbursementTypeSlug)
        },
        tableData() {
            const sectionData = this.reimbursementTypes.map((r, idx) => ({
                id: idx,
                isActive: this.currentReimbursementTypeSlug && r.slug == this.currentReimbursementTypeSlug,
                object: r,
                cells: [
                    r.name,
                    r.has_been_used ? 'Yes' : 'No',
                    r.allow_multiple_per_company,
                ],
            }))
            return [sectionData]
        },
    },
    data() {
        return {
            reimbursementTypes: [],
            dataLoaded: false,
            currentReimbursementTypeSlug: null,
            addModalOpen: false,

            headers: [
                {label: 'Reimbursement Type', classes: '', isSearchable: true, defaultSort: true},
                {label: 'Has Been Used', classes: 'cw-5', isFilterable: true},
                {label: 'Allow Multiple', classes: 'cw-6', type: 'checkmark', isFilterable: true},
            ],
            sections: [
                {title: '', defaultIsClosed: false, id: 1},
            ],
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Tax Engine / Reimbursement Types')
        this.getData()
    },
    methods: {
        getData() {
            this.dataLoaded = false
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/admin/tax-engine/reimbursement-types`).then(resp => {
                this.reimbursementTypes = resp
                this.dataLoaded = true
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
        onUpdate(reimbursementType) {
            if (!reimbursementType) {
                return this.getData()
            }
            const existing = this.reimbursementTypes.find(x => x.slug == reimbursementType.slug)
            if (existing) {
                Object.assign(existing, reimbursementType)
            }
            else { this.getData() }
        },
    },
}

</script>
